export const Progress = {
  baseStyle: {
    filledTrack: {
      bg: 'primary.normal',
    },
  },
}
